import React, { createContext, useContext, useState } from "react";

export type BackgroundMode = "video" | "logo" | "both" | "none";

interface BackgroundModeContextValue {
  mode: BackgroundMode;
  setMode: (mode: BackgroundMode) => void;
}

const BackgroundModeContext = createContext<BackgroundModeContextValue | null>(
  null
);

export function BackgroundModeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [mode, setModeState] = useState<BackgroundMode>(() => {
    // Lade aus localStorage oder verwende "video" als Standard
    const saved = localStorage.getItem("background-mode");
    if (
      saved === "video" ||
      saved === "logo" ||
      saved === "both" ||
      saved === "none"
    ) {
      return saved as BackgroundMode;
    }
    return "video"; // Standard: Video
  });

  const setMode = (newMode: BackgroundMode) => {
    setModeState(newMode);
    localStorage.setItem("background-mode", newMode);
  };

  return (
    <BackgroundModeContext.Provider value={{ mode, setMode }}>
      {children}
    </BackgroundModeContext.Provider>
  );
}

export function useBackgroundMode() {
  const context = useContext(BackgroundModeContext);
  if (!context) {
    throw new Error(
      "useBackgroundMode must be used within a BackgroundModeProvider"
    );
  }
  return context;
}

export function useBackgroundModeOptional() {
  return useContext(BackgroundModeContext);
}
